import {
    AfterViewInit,
    booleanAttribute,
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    HostListener,
    Input,
    signal,
    ViewChild,
    WritableSignal
} from '@angular/core';
import { ContentBlockComponent } from '../content-block/content-block.component';
import { SanitizeUrlPipe } from '../../pipes/sanitize-url.pipe';
import { SanitizeHtmlPipe } from '../../pipes/sanitize-html.pipe';

@Component({
    selector: 'nw-turtl-block',
    imports: [ContentBlockComponent, SanitizeUrlPipe, SanitizeHtmlPipe],
    templateUrl: './turtl-block.component.html',
    styleUrl: './turtl-block.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TurtlBlockComponent implements AfterViewInit {
    @Input({ transform: booleanAttribute }) border: boolean = false;

    @Input() title?: string;
    @Input() content?: string;
    @Input() footnote?: string;
    @Input() turtleurl!: string;
    @Input() ratio: number = 0.65;

    @ViewChild('iframe') iframe!: ElementRef;

    @HostListener('window:resize') windowResize(): void {
        this.resize();
    }

    public iframeHeight$$: WritableSignal<number> = signal(200);

    public ngAfterViewInit(): void {
        this.resize();
    }

    private resize(): void {
        this.iframeHeight$$.set(this.iframe?.nativeElement?.clientWidth * this.ratio);
    }
}
